export default function PlusIcon(props) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25">
            <path stroke="#EF8B22" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M12.5 5.2v14.6m-7.3-7.3h14.6"/>
        </svg>
    )
}